module.exports = __webpack_public_path__ + "img/become4.5759869f.png";